import { jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import HmimhwPropertySearch from "@zillow/hmimhw-property-search";
const PUBLIC_CONFIG_VALUES_MAP = {
  test: {
    addressAutocompleteURL: "https://static.qa.zillow.net/autocomplete/v3/suggestions/",
    gdpServiceUrl: "https://www.qa.zillow.net/graphql/",
    zatlasEndpoint: "https://proxy.dev.zillow.net/develop/"
  },
  prod: {
    addressAutocompleteURL: "https://www.zillowstatic.com/autocomplete/v3/suggestions/",
    gdpServiceUrl: "https://www.zillow.com/graphql/",
    zatlasEndpoint: "https://proxy.zillowapi.com/prod/"
  }
};
const wrapperStyles = css({
  maxWidth: "100%",
  width: "720px"
});
const BlockHmimhwPropertySearch = ({
  attrs,
  index
}) => {
  const NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /* @__PURE__ */ jsx("div", { className: wrapperStyles, children: /* @__PURE__ */ jsx(HmimhwPropertySearch, { publicConfigValues: NEXT_PUBLIC_ENV && PUBLIC_CONFIG_VALUES_MAP[NEXT_PUBLIC_ENV] || PUBLIC_CONFIG_VALUES_MAP.test, isLightboxBackgroundLocked: false, ...attrs }, index) });
};
export {
  BlockHmimhwPropertySearch as default
};
